export default __webpack_public_path__ + "static/biznesowe-d86a52dff68f4a0383a3587915f3cba6.jpeg";